import { configureStore } from "@reduxjs/toolkit";
// Or from '@reduxjs/toolkit/query/react';
// import { setupListeners } from '@reduxjs/toolkit/query';

import authReducer from "./Data/features/authSlice";
import dashboardReducer from "./Data/features/dashboardSlice";
import settingsReducer from "./Data/features/settingSlice";
import userReducer from "./Data/features/userSlice";
import sessionMiddleware from "./Data/middleware/sessionMiddleware";

import { setupListeners } from "@reduxjs/toolkit/query";
import { businessTypeApi } from "./Data/services/businessTypeApi";
import { cuisineTypeApi } from "./Data/services/cuisineTypeApi";
import { customerApi } from "./Data/services/customerApi";
import { dashboardApi } from "./Data/services/dashboardApi";
import { deliveryApi } from "./Data/services/deliveryApi";
import { notificationApi } from "./Data/services/notificationApi";
import { ordersApi } from "./Data/services/ordersApi";
import { reportsApi } from "./Data/services/reportsApi";
import { reportTypeApi } from "./Data/services/reportTypeApi";
import { restaurantApi } from "./Data/services/restaurantApi";
import { riderApi } from "./Data/services/ridersApi";
import { settingApi } from "./Data/services/settingApi";
import { transactionApi } from "./Data/services/transactionApi";
import { userApi } from "./Data/services/userApi";
import { userAuthApi } from "./Data/services/userAuthApi";
import { baseApi } from "./Data/services/baseApi";

export const store = configureStore({
  reducer: {
    // Add the generated reducer as a specific top-level slice
    // RTK Query API
    // [dashboardApi.reducerPath]: dashboardApi.reducer,
    // [settingApi.reducerPath]: settingApi.reducer,
    // [userAuthApi.reducerPath]: userAuthApi.reducer,
    // [userApi.reducerPath]: userApi.reducer,
    // [customerApi.reducerPath]: customerApi.reducer,
    // [restaurantApi.reducerPath]: restaurantApi.reducer,
    // [riderApi.reducerPath]: riderApi.reducer,
    // [ordersApi.reducerPath]: ordersApi.reducer,
    // [transactionApi.reducerPath]: transactionApi.reducer,
    // [reportsApi.reducerPath]: reportsApi.reducer,
    // [notificationApi.reducerPath]: notificationApi.reducer,
    // [businessTypeApi.reducerPath]: businessTypeApi.reducer,
    // [cuisineTypeApi.reducerPath]: cuisineTypeApi.reducer,
    // [reportTypeApi.reducerPath]: reportTypeApi.reducer,
     [baseApi.reducerPath]: baseApi.reducer,
    // Local storage Redux
    user: userReducer,
    settings: settingsReducer,
    dashboard: dashboardReducer,
    authInfo: authReducer,
  },
  // load from local storage
  preloadedState: loadFromLocalStorage(), //todo:

  // Adding the api middleware enables caching, invalidation, polling,
  // and other useful features of `rtk-query`.
  //todo:
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat([
      baseApi.middleware,
      sessionMiddleware, // for session check each api response
    ]),
});

//todo:
function saveToLocalStorage(state) {
  try {
    const serialState = JSON.stringify(state);
    localStorage.setItem("reduxStore", serialState);
  } catch (e) {
    console.warn(e);
  }
}

//todo:
function loadFromLocalStorage() {
  try {
    const serialisedState = localStorage.getItem("reduxStore");
    if (serialisedState === null) return undefined;
    return JSON.parse(serialisedState);
  } catch (e) {
    console.warn(e);
    return undefined;
  }
}

//todo:
store.subscribe(() => saveToLocalStorage(store.getState()));

// optional, but required for refetchOnFocus/refetchOnReconnect behaviors
// see `setupListeners` docs - takes an optional callback as the 2nd arg for customization
setupListeners(store.dispatch); //todo:
